/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "কালি",
        "-2": "পৰহি",
        "0": "আজি",
        "1": "কাইলৈ",
        "2": "পৰহিলৈ",
        "future": {
          "one": "{0} দিনত",
          "other": "{0} দিনত"
        },
        "past": {
          "one": "{0} দিন পূৰ্বে",
          "other": "{0} দিন পূৰ্বে"
        }
      },
      "day-narrow": {
        "-1": "কালি",
        "-2": "পৰহি",
        "0": "আজি",
        "1": "কাইলৈ",
        "2": "পৰহিলৈ",
        "future": {
          "one": "{0} দিনত",
          "other": "{0} দিনত"
        },
        "past": {
          "one": "{0} দিন পূৰ্বে",
          "other": "{0} দিন পূৰ্বে"
        }
      },
      "day-short": {
        "-1": "কালি",
        "-2": "পৰহি",
        "0": "আজি",
        "1": "কাইলৈ",
        "2": "পৰহিলৈ",
        "future": {
          "one": "{0} দিনত",
          "other": "{0} দিনত"
        },
        "past": {
          "one": "{0} দিন পূৰ্বে",
          "other": "{0} দিন পূৰ্বে"
        }
      },
      "hour": {
        "0": "এইটো ঘণ্টাত",
        "future": {
          "one": "{0} ঘণ্টাত",
          "other": "{0} ঘণ্টাত"
        },
        "past": {
          "one": "{0} ঘণ্টা পূৰ্বে",
          "other": "{0} ঘণ্টা পূৰ্বে"
        }
      },
      "hour-narrow": {
        "0": "এইটো ঘণ্টাত",
        "future": {
          "one": "{0} ঘণ্টাত",
          "other": "{0} ঘণ্টাত"
        },
        "past": {
          "one": "{0} ঘণ্টা পূৰ্বে",
          "other": "{0} ঘণ্টা পূৰ্বে"
        }
      },
      "hour-short": {
        "0": "এইটো ঘণ্টাত",
        "future": {
          "one": "{0} ঘণ্টাত",
          "other": "{0} ঘণ্টাত"
        },
        "past": {
          "one": "{0} ঘণ্টা পূৰ্বে",
          "other": "{0} ঘণ্টা পূৰ্বে"
        }
      },
      "minute": {
        "0": "এইটো মিনিটত",
        "future": {
          "one": "{0} মিনিটত",
          "other": "{0} মিনিটত"
        },
        "past": {
          "one": "{0} মিনিট পূৰ্বে",
          "other": "{0} মিনিট পূৰ্বে"
        }
      },
      "minute-narrow": {
        "0": "এইটো মিনিটত",
        "future": {
          "one": "{0} মিনিটত",
          "other": "{0} মিনিটত"
        },
        "past": {
          "one": "{0} মিনিট পূৰ্বে",
          "other": "{0} মিনিট পূৰ্বে"
        }
      },
      "minute-short": {
        "0": "এইটো মিনিটত",
        "future": {
          "one": "{0} মিনিটত",
          "other": "{0} মিনিটত"
        },
        "past": {
          "one": "{0} মিনিট পূৰ্বে",
          "other": "{0} মিনিট পূৰ্বে"
        }
      },
      "month": {
        "-1": "যোৱা মাহ",
        "0": "এই মাহ",
        "1": "অহা মাহ",
        "future": {
          "one": "{0} মাহত",
          "other": "{0} মাহত"
        },
        "past": {
          "one": "{0} মাহ পূৰ্বে",
          "other": "{0} মাহ পূৰ্বে"
        }
      },
      "month-narrow": {
        "-1": "যোৱা মা.",
        "0": "এই মা.",
        "1": "অহা মাহ",
        "future": {
          "one": "{0} মাহত",
          "other": "{0} মাহত"
        },
        "past": {
          "one": "{0} মাহ পূৰ্বে",
          "other": "{0} মাহ পূৰ্বে"
        }
      },
      "month-short": {
        "-1": "যোৱা মাহ",
        "0": "এই মাহ",
        "1": "অহা মাহ",
        "future": {
          "one": "{0} মাহত",
          "other": "{0} মাহত"
        },
        "past": {
          "one": "{0} মাহ পূৰ্বে",
          "other": "{0} মাহ পূৰ্বে"
        }
      },
      "nu": ["beng"],
      "quarter": {
        "-1": "যোৱা তিনি মাহ",
        "0": "এই তিনি মাহ",
        "1": "অহা তিনি মাহ",
        "future": {
          "one": "{0} তিনি মাহত",
          "other": "{0} তিনি মাহত"
        },
        "past": {
          "one": "{0} তিনি মাহ পূৰ্বে",
          "other": "{0} তিনি মাহ পূৰ্বে"
        }
      },
      "quarter-narrow": {
        "-1": "যোৱা তিনি মাহ",
        "0": "এই তিনি মাহ",
        "1": "অহা তিনি মাহ",
        "future": {
          "one": "{0} তিনি মাহত",
          "other": "{0} তিনি মাহত"
        },
        "past": {
          "one": "{0} তিনি মাহ পূৰ্বে",
          "other": "{0} তিনি মাহ পূৰ্বে"
        }
      },
      "quarter-short": {
        "-1": "যোৱা তিনি মাহ",
        "0": "এই তিনি মাহ",
        "1": "অহা তিনি মাহ",
        "future": {
          "one": "{0} তিনি মাহত",
          "other": "{0} তিনি মাহত"
        },
        "past": {
          "one": "{0} তিনি মাহ পূৰ্বে",
          "other": "{0} তিনি মাহ পূৰ্বে"
        }
      },
      "second": {
        "0": "এতিয়া",
        "future": {
          "one": "{0} ছেকেণ্ডত",
          "other": "{0} ছেকেণ্ডত"
        },
        "past": {
          "one": "{0} ছেকেণ্ড পূৰ্বে",
          "other": "{0} ছেকেণ্ড পূৰ্বে"
        }
      },
      "second-narrow": {
        "0": "এতিয়া",
        "future": {
          "one": "{0} ছেকেণ্ডত",
          "other": "{0} ছেকেণ্ডত"
        },
        "past": {
          "one": "{0} ছেকেণ্ড পূৰ্বে",
          "other": "{0} ছেকেণ্ড পূৰ্বে"
        }
      },
      "second-short": {
        "0": "এতিয়া",
        "future": {
          "one": "{0} ছেকেণ্ডত",
          "other": "{0} ছেকেণ্ডত"
        },
        "past": {
          "one": "{0} ছেকেণ্ড পূৰ্বে",
          "other": "{0} ছেকেণ্ড পূৰ্বে"
        }
      },
      "week": {
        "-1": "যোৱা সপ্তাহ",
        "0": "এই সপ্তাহ",
        "1": "অহা সপ্তাহ",
        "future": {
          "one": "{0} সপ্তাহত",
          "other": "{0} সপ্তাহত"
        },
        "past": {
          "one": "{0} সপ্তাহ পূৰ্বে",
          "other": "{0} সপ্তাহ পূৰ্বে"
        }
      },
      "week-narrow": {
        "-1": "যোৱা সপ্তাহ",
        "0": "এই সপ্তাহ",
        "1": "অহা সপ্তাহ",
        "future": {
          "one": "{0} সপ্তাহত",
          "other": "{0} সপ্তাহত"
        },
        "past": {
          "one": "{0} সপ্তাহ পূৰ্বে",
          "other": "{0} সপ্তাহ পূৰ্বে"
        }
      },
      "week-short": {
        "-1": "যোৱা সপ্তাহ",
        "0": "এই সপ্তাহ",
        "1": "অহা সপ্তাহ",
        "future": {
          "one": "{0} সপ্তাহত",
          "other": "{0} সপ্তাহত"
        },
        "past": {
          "one": "{0} সপ্তাহ পূৰ্বে",
          "other": "{0} সপ্তাহ পূৰ্বে"
        }
      },
      "year": {
        "-1": "যোৱা বছৰ",
        "0": "এই বছৰ",
        "1": "অহা বছৰ",
        "future": {
          "one": "{0} বছৰত",
          "other": "{0} বছৰত"
        },
        "past": {
          "one": "{0} বছৰৰ পূৰ্বে",
          "other": "{0} বছৰৰ পূৰ্বে"
        }
      },
      "year-narrow": {
        "-1": "যোৱা বছৰ",
        "0": "এই বছৰ",
        "1": "অহা বছৰ",
        "future": {
          "one": "{0} বছৰত",
          "other": "{0} বছৰত"
        },
        "past": {
          "one": "{0} বছৰৰ পূৰ্বে",
          "other": "{0} বছৰৰ পূৰ্বে"
        }
      },
      "year-short": {
        "-1": "যোৱা বছৰ",
        "0": "এই বছৰ",
        "1": "অহা বছৰ",
        "future": {
          "one": "{0} বছৰত",
          "other": "{0} বছৰত"
        },
        "past": {
          "one": "{0} বছৰৰ পূৰ্বে",
          "other": "{0} বছৰৰ পূৰ্বে"
        }
      }
    },
    "locale": "as"
  });
}